import { EventViewInformationPageContent } from 'components/eventView/pages/EVInformationPageContent';
import { SplitTitle } from 'components/guide/split/SplitTitle';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVInformationPagePC = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { informationList } = ctxEventView;

    const title = Localization.INFO;

    return (
        <S_EVInformationPagePC className={props.className} id={'info'}>
            <S_SplitTitle number={informationList?.length} title={title} />
            <EventViewInformationPageContent />
        </S_EVInformationPagePC>
    );
};

const S_EVInformationPagePC = styled.div``;

const S_SplitTitle = styled(SplitTitle)`
    margin: 60px 0 60px 0;
`;
